import { StatementService, InvoiceService } from "core/services/cef";
import StatementsAndInvoicesStore, { ItemType } from "core/stores/statements-and-invoices.store";

class StatementsAndInvoicesStoreManager {
    private _statementService = new StatementService(null, true);
    private _invoiceService = new InvoiceService(null, true);
    private _store: StatementsAndInvoicesStore;
    lastResponse: any = null;

    constructor(store: StatementsAndInvoicesStore) {
        this._store = store;
    }

    initialize(statementAbortController: AbortController | null, invoiceController: AbortController | null) {
        this._statementService = new StatementService(statementAbortController);
        this._invoiceService = new InvoiceService(invoiceController);
    }

    get store() {
        return this._store;
    }

    async getItems(type: ItemType, startDate: Date | string, endDate: Date | string) {
        if (!type) {
            console.log("Cannot download as type not set");
            return null;
        }

        console.log(`Get items: ${type}`);

        this.lastResponse = type === ItemType.invoice
            ? await this._invoiceService.getInvoices(startDate, endDate)
            : await this._statementService.getStatements(startDate, endDate);

        const newItems = this.lastResponse.data || [];

        for (let i = 0; i < newItems.length; i++) {
            const item = newItems[i];
            item.documentDate = item.invoiceDate ? item.invoiceDate : item.data.from;
        }

        const useDemoData = false;

        if (useDemoData) {
            return this._getTestData(newItems);
        }

        this.store.updateItems(newItems);

        return newItems;
    }

    // Extra data to test pagination
    private _getTestData(newItems: any[]) {
        const list = new Array<any>();

        for (let i = 0; i < 10; i++) {
            newItems.forEach((x: any) => {
                list.push(x);
            });
        }

        this.store.updateItems(list);

        return list;
    }

    download(type: ItemType, documentId: string) {
        return type === ItemType.invoice
            ? this._invoiceService.downloadInvoice(documentId)
            : this._statementService.downloadStatement(documentId);
    }
}

export default StatementsAndInvoicesStoreManager;
